import * as React from "react"
import { User, Route, RoutesOutput, Employee } from "../../types/types";
import SimpleFormat from "../../utils/SimpleFormat";
import EmployeeComponent from "./components/Employee"

export type AboutRoutes = {
  advertise: Route
  new_user_registration: Route
}

type Props = {
  current_user: User
  routes: RoutesOutput<AboutRoutes>
  employees: Employee[]
}

export const About = (props: Props) : JSX.Element => (
  <div>
    <div className="page-section page-section--yellow page-section--slim home-filters">
      <div className="grid-container">
        <div className="grid-40 prefix-30 suffix-30 tablet-grid-60 tablet-prefix-20 tablet-suffix-20 tac">
          <p>
            {I18n.t('about.intro.text')}
          </p>
        </div>
      </div>
    </div>
    <div className="page-section page-section--pt">
      <div className="page-section__head">
        <div className="grid-container grid-container--medium">
          <div className="grid-100 tac">
            <h1 className="page-section__title">
              {I18n.t('about.intro.page-title')}
            </h1>
          </div>
        </div>
      </div>
      <div className="grid-container grid-container--medium">
        <ul className="features">
          <li className="features__item">
            {I18n.t('about.gites-kpi.first')}
          </li>
          <li className="features__item">
            {I18n.t('about.gites-kpi.second')}
          </li>
          <li className="features__item">
            {I18n.t('about.gites-kpi.third')}
          </li>
        </ul>
      </div>
    </div>
    <div className="page-section page-section--bt">
      <div className="grid-container grid-container--medium">
        <div className="grid-50 tablet-grid-50 mobile-mb">
          <h4>
            {I18n.t('about.call-to.register-title')}
          </h4>
          <div className="about-content">
            <SimpleFormat text={I18n.t('about.call-to.register')} />
          </div>
          {
            !props.current_user ?
              <p>
                <a href={props.routes.get('new_user_registration').url} className="btn btn--yellow">
                  {I18n.t('about.call-to.register-button')}
                </a>
              </p>
              : ''
          }
        </div>
        <div className="grid-50 tablet-grid-50 mobile-mb">
          <h4>
            {I18n.t('about.call-to.advertise-title')}
          </h4>
          <div className="about-content">
            <SimpleFormat text={I18n.t('about.call-to.advertise')} />
          </div>
          <p>
            <a href={props.routes.get('advertise').path} className='btn btn--yellow'>{I18n.t('about.call-to.advertise-button')}</a>
          </p>
        </div>
      </div>
    </div>
    <div className="page-section page-section--bt">
      <div className="page-section__head">
        <div className="grid-container grid-container--medium">
          <div className="grid-100 tac">
            <h2 className="page-section__title">
              {I18n.t('about.address.title')}
            </h2>
          </div>
        </div>
      </div>
      <div className="grid-container grid-container--medium">
        {
          props.employees.map((x, i) => {
            const klass = props.employees.length == 3
              ? "grid-33 tablet-grid-100 mobile-grid-100"
              : i % 2 == 0
                ? "grid-35 prefix-10 suffix-5 tablet-grid-50 mobile-grid-100"
                : "grid-35 prefix-5 suffix-10 tablet-grid-50 mobile-grid-100"

            return <EmployeeComponent
              key={x.name}
              employee={x}
              className={klass}
            />
          })
        }
      </div>
    </div>
    <div className="page-section page-section--bt">
      <div className="grid-container grid-container--medium">
        <div className="grid-30 tablet-grid-33 tac mobile-tal mobile-mb">
          <div>
            <div>
              {I18n.t('about.address.gites')}
            </div>
            <div>
              {I18n.t('about.address.street')}
            </div>
            <div>
              {I18n.t('about.address.zipcode-city')}
            </div>
          </div>
        </div>
        <div className="grid-35 suffix-5 tablet-grid-33 tac mobile-tal mobile-mb">
          <div className="telephone">
            {I18n.t('about.address.telephone-label')}
          </div>
          <ul className="infolist infolist--justify">
            <li className="infolist__item">
              <strong className="infolist__label">
                {I18n.t('about.address.telnl-label')}
              </strong>
              <span className="infolist__value">
                {I18n.t('about.address.telnl')}
              </span>
            </li>
            <li className="infolist__item">
              <strong className="infolist__label">
                {I18n.t('about.address.tel-fr-label')}
              </strong>
              <span className="infolist__value">
                {I18n.t('about.address.tel-fr')}
              </span>
            </li>
            <li className="infolist__item">
              <strong className="infolist__label">
                {I18n.t('about.address.tel-be-label')}
              </strong>
              <span className="infolist__value">
                {I18n.t('about.address.tel-be')}
              </span>
            </li>
            <li className="infolist__item">
              <strong className="infolist__label">
                {I18n.t('about.address.tel-en-label')}
              </strong>
              <span className="infolist__value">
                {I18n.t('about.address.tel-en')}
              </span>
            </li>
            <li className="infolist__item">
              <strong className="infolist__label">
                {I18n.t('about.address.email-label')}
              </strong>
              <span className="infolist__value">
                <a href={`mailto:${I18n.t('about.address.email')}`}>{I18n.t('about.address.email')}</a>
              </span>
            </li>
          </ul>
        </div>
        <div className="grid-30 tablet-grid-33 tac mobile-tal mobile-mb">
          <p>
            {I18n.t('about.address.kvk')}
          </p>
        </div>
      </div>
    </div>

  </div>
)

